import React from 'react';

import { StyledTypography } from 'styles/common';

import theme from 'constants/theme';

export const Typography1 = ({ children, ...styledProps }) => (
  <StyledTypography variant="h5" customColor={theme.palette.text.black} {...styledProps}>
    {children}
  </StyledTypography>
);

export const Typography2 = ({ children, ...styledProps }) => (
  <StyledTypography variant="body2" customColor={theme.palette.text.label} {...styledProps}>
    {children}
  </StyledTypography>
);

export const Typography3 = ({ children, ...styledProps }) => (
  <StyledTypography variant="body2" weight={600} customColor={theme.palette.text.heading} {...styledProps}>
    {children}
  </StyledTypography>
);

export const Typography4 = ({ children, ...styledProps }) => (
  <StyledTypography variant="body2" customColor={theme.palette.text.heading} {...styledProps}>
    {children}
  </StyledTypography>
);

export const Typography5 = ({ children, ...styledProps }) => (
  <StyledTypography variant="caption" weight={600} customColor={theme.palette.text.heading} {...styledProps}>
    {children}
  </StyledTypography>
);

export const Typography6 = ({ children, ...styledProps }) => (
  <StyledTypography
    variant="h5"
    weight={600}
    style={{ fontSize: '20px' }}
    customColor={theme.palette.text.heading}
    {...styledProps}
  >
    {children}
  </StyledTypography>
);

export const Typography7 = ({ children, ...styledProps }) => (
  <StyledTypography variant="body1" customColor={theme.palette.text.heading} {...styledProps}>
    {children}
  </StyledTypography>
);

export const Typography8 = ({ children, ...styledProps }) => (
  <StyledTypography variant="caption" display="block" customColor={theme.palette.text.label} {...styledProps}>
    {children}
  </StyledTypography>
);

export const Typography9 = ({ children, ...styledProps }) => (
  <StyledTypography variant="caption" display="block" customColor={theme.palette.text.heading} {...styledProps}>
    {children}
  </StyledTypography>
);

export const Typography10 = ({ children, ...styledProps }) => (
  <StyledTypography variant="body1" {...styledProps}>
    {children}
  </StyledTypography>
);

export const Typography11 = ({ children, ...styledProps }) => (
  <StyledTypography style={{ fontSize: '20px' }} variant="body1" {...styledProps}>
    {children}
  </StyledTypography>
);

export const Typography12 = ({ children, ...styledProps }) => (
  <StyledTypography style={{ fontSize: '12px' }} variant="body1" {...styledProps}>
    {children}
  </StyledTypography>
);

export const Typography13 = ({ children, ...styledProps }) => (
  <StyledTypography style={{ fontSize: '14px' }} variant="body1" {...styledProps}>
    {children}
  </StyledTypography>
);

export const Typography14 = ({ children, ...styledProps }) => (
  <StyledTypography style={{ fontSize: '16px' }} variant="body1" {...styledProps}>
    {children}
  </StyledTypography>
);

export const Typography15 = ({ children, ...styledProps }) => (
  <StyledTypography style={{ fontSize: '24px' }} variant="body1" {...styledProps}>
    {children}
  </StyledTypography>
);

// this is used mostly in headings of settings panel
// in future if anymore panels are added, use this
export const Typography16 = ({ children, ...styledProps }) => (
  <StyledTypography
    style={{ fontSize: '24px' }}
    variant="body1"
    customColor={theme.palette.text.heading}
    {...styledProps}
  >
    {children}
  </StyledTypography>
);

// this is used mostly in sub-headings of settings panel
// in future if anymore panels are added, use this
export const Typography17 = ({ children, ...styledProps }) => (
  <StyledTypography
    style={{ fontSize: '12px' }}
    customColor={theme.palette.text.label}
    variant="body1"
    {...styledProps}
  >
    {children}
  </StyledTypography>
);

export const Typography18 = ({ children, ...styledProps }) => (
  <StyledTypography style={{ fontSize: '14px', whiteSpace: 'pre-line' }} variant="body1" {...styledProps}>
    {children}
  </StyledTypography>
);

export const Typography40 = ({ children, ...styledProps }) => (
  <StyledTypography
    style={{ fontSize: '40px', whiteSpace: 'pre-line', lineHeight: '50.28px' }}
    variant="body1"
    {...styledProps}
  >
    {children}
  </StyledTypography>
);
